module.exports = __webpack_public_path__ + "img/email-marketing.275aeee6.svg";